import React from 'react';
import { Link } from 'react-router-dom';
import './ArchitecturalPage.css';

  const services = [
    {
    title: 'Dyed Reflective Film',
    description: 'Enhances privacy and solar control with a stylish look. Ideal for energy savings and glare reduction in modern spaces.',
    link: '/dyed-reflective'
    },
    {
    title: '2-Ply Reflective Film',
    description: 'Dual-layer construction for improved durability and heat rejection. Perfect for commercial and residential buildings needing extra protection.',
    link: '/2ply-reflective'
    },
    {
    title: '3-Ply Reflective Film',
    description: 'Triple-layered for maximum strength, security, and solar performance. Designed for demanding environments and high-traffic architectural applications.',
    link: '/3ply-reflective'
  },
    {
    title: 'Signature Sputtering',
    description: 'Advanced sputtered technology delivers superior clarity, UV protection, and heat rejection. Premium choice for architectural aesthetics and comfort.',
    link: '/signature-sputtering'
  },
    {
    title: 'Safety & Security Film',
    description: 'Protects glass from breakage, forced entry, and accidents. Enhances safety for occupants in both public and private buildings.',
    link: '/safety-security'
    },
    {
    title: 'Decorative Film',
    description: 'Transforms glass with patterns, frosts, and colors. Adds privacy and style to offices, homes, and commercial interiors.',
    link: '/decorative'
  }
];

const ArchitecturalPage = () => {
  return (
    <div className="architectural-main">
      <section className="architectural-top custom-arch-top">
        <div className="arch-top-overlay" />
        <div className="arch-top-diagonal" />
        <div className="architectural-top-content">
          <h1>Architectural Solutions</h1>
        </div>
      </section>

      <section className="arch-services-section">
        <h2 className="arch-services-title">Our Architecture Services</h2>
        <div className="arch-services-list">
          {services.map((service, idx) => (
            <div className={`arch-service-card service-${service.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`} key={idx}>
              <div className="arch-service-overlay" />
              <div className="arch-service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to={service.link} className="arch-service-btn">Learn More</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ArchitecturalPage; 